<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('search.title') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('StatisticsList.search.Min Price') }}</label>
                        <InputText id="nameuser" :class="`${error.name ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="min_point" />
                        <div class="text-red">{{ error.name }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="mobileuser">{{ $t('StatisticsList.search.Max Price') }}</label>
                        <InputText id="mobileuser" :class="`${error.mobile ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="max_point" />
                        <div class="text-red">{{ error.mobile }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label>{{ $t('StatisticsList.search.Children') }}</label>
                        <Dropdown id="state" v-model="has_children" :options="childrens" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="mobileuser">{{ $t('StatisticsList.search.Children Age') }}</label>
                        <MultiSelect v-model="childrenAge" :options="c_ages" optionLabel="name" placeholder="선택" @change="helloqwe" />
                        <div class="text-red">{{ error.mobile }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('StatisticsList.search.Gender') }}</label>
                        <Dropdown id="state" v-model="gender" :options="genders" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="mobileuser">{{ $t('StatisticsList.search.User Age Group') }}</label>
                        <Dropdown id="state" v-model="user_age_group" :options="age_groups" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown>
                        <div class="text-red">{{ error.mobile }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="emailuser">{{ $t('StatisticsList.search.Marital Status') }}</label>
                        <Dropdown id="state" v-model="marital_status" :options="marital_statuss" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown>
                        <div class="text-red">{{ error.email }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="emailuser">{{ $t('StatisticsList.search.Pet') }}</label>
                        <Dropdown id="state" v-model="pet" :options="pets" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown>
                        <div class="text-red">{{ error.email }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="emailuser">{{ $t('StatisticsList.search.Product Category') }}</label>
                        <InputText id="emailuser" :class="`${error.email ? 'p-invalid' : ''}`" type="email" :placeholder="$t('search.placeholder.search')" v-model="product_category3" />
                        <div class="text-red">{{ error.email }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('StatisticsList.search.Start Date') }}</label>
                        <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="start_date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                        <div class="text-red">{{ error.calendarValue }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('StatisticsList.search.End Date') }}</label>
                        <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="end_date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                        <div class="text-red">{{ error.calendarValue }}</div>
                    </div>
                </div>
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                        <!-- <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button> -->
                    </div>
                    <div>
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="searchuser"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('StatisticsList.list.Statistics-product List') }}</h5>
                    </div>
                    <div>
                        <!-- <Button label="Primary" class="p-mr-2 p-mb-2" @click="excelUpload"><i class="pi pi-download p-mr-2"></i>{{ $t('Upload Excel') }}</Button> -->
                        <!-- <Button label="Primary" class="p-mr-2 p-mb-2" @click="openBasic"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button> -->
                    </div>
                    <Dialog header="Please enter reason for download this file" v-model:visible="displayBasic" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
                        <h5 style="margin-top: 10px">Enter Reason</h5>
                        <Textarea v-model="downloadReason" rows="10" style="width: 100%" maxlength="200" @input="Whenchange" />
                        <small style="color: gray">200 character maximum.</small>
                        <template #footer>
                            <Button label="Submit" icon="pi pi-check" @click="exceldownload" :disabled="IsDisable" />
                            <Button label="Cancel" icon="pi pi-times" @click="closeBasic" autofocus />
                        </template>
                    </Dialog>
                </div>
                <DataTable :value="customer1" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty> No Data found. </template>
                    <template #loading> Loading data. Please wait. </template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                   <Column field="slNO" :header="$t('#')">
                        <template #body="{ data }">
                            <span class="p-column-title">slNo</span>
                            {{ data.slNo }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('StatisticsList.list.Breadcrumb')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Breadcrumb</span>
                            {{ `${data.product_category}/${data.product_category2}//${data.product_category3}` }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('StatisticsList.list.Product 3rd Category')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Product 3rd Category</span>
                            <router-link :to="'/statistics/product_category_final'" @mouseenter="setProductCategory(data.product_category, data.product_category2, data.product_category3)">
                                {{ data.product_category2 == '' ? 'No Data' : data.product_category2 }}
                            </router-link>
                        </template>
                    </Column>
                    <Column :header="$t('StatisticsList.list.Total Spend (in WON)')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Total Spend (in WON)</span>
                            &#8361; {{ currenyformat(data.total_price) }}
                        </template>
                    </Column>
                    <Column :header="$t('StatisticsList.list.Numbers of Receipts')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Numbers of Receipts</span>
                            {{ data.no_of_receipt }}
                        </template>
                    </Column>
                    <Column :header="$t('StatisticsList.list.Number of user')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Number of user</span>
                            {{ data.no_of_users }}
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import StatisticsService from '../../service/API/StatisticsService';
import axios from 'axios';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            downloadReason: '',
            IsDisable: true,
            displayBasic: false,
            c_ages: [
                { name: 'INFANT', code: '10_20' },
                { name: 'ADULT', code: '21_30' },
                { name: 'SCHOOL_AGED_CHILDREN', code: '31_40' },
            ],
            selected: [],
            selectedItemss: [],
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,

            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
            ],
            pets: [
                { name: 'Yes', code: '1' },
                { name: 'No', code: '0' },
            ],
            childrens: [
                { name: 'Yes', code: '1' },
                { name: 'No', code: '0' },
            ],
            marital_statuss: [
                { name: 'married', code: '1' },
                { name: 'unmarried', code: '0' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            has_children: '',
            product_category: '',
            children: '',
            childrenAge: '',
            gender: '',
            marital_status: '',
            pet: '',
            start_date: '',
            end_date: '',
            min_point: '',
            max_point: '',
            user_age_group: '',
            product_category3: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.statisticsService = new StatisticsService();
    },
    mounted() {
        this.getlist();
    },
    watch: {},
    methods: {
        Whenchange() {
            if (this.downloadReason != '') {
                this.IsDisable = false;
            } else {
                this.IsDisable = true;
            }
        },
        openBasic() {
            this.displayBasic = true;
        },
        closeBasic() {
            this.displayBasic = false;
        },
        currenyformat(val){
            return val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        helloqwe() {
            let xyz = [];
            let data = this.childrenAge;
            for (var a = 0; a < data.length; a++) {
                xyz.push(data[a].name);
            }
            this.selectedItemss = xyz;
        },
        setProductCategory(p1, p2, p3) {
            localStorage.setItem('pcategory', p1);
            localStorage.setItem('pcategory2', p2);
            localStorage.setItem('pcategory3', p3);
        },
        getlist() {
            this.statisticsService
                .reportCategoryListByCategoryThird(
                    localStorage.getItem('pcategory'),
                    localStorage.getItem('pcategory2'),
                    this.product_category3,
                    this.has_children == '' ? '' : this.has_children.code,
                    this.user_age_group == '' ? '' : this.user_age_group.code,
                    this.gender == '' ? '' : this.gender.code,
                    this.marital_status == '' ? '' : this.marital_status.code,
                    this.pet == '' ? '' : this.pet.code,
                    this.start_date,
                    this.end_date,
                    this.selectedItemss,
                    this.min_point,
                    this.max_point
                )
                .then((data) => {
                    let list = data.map((item, index) => ({ ...item, slNo: index + 1 }));
                    this.customer1 = list;
                    this.loading1 = false;
                    this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                });
        },
        resetUser() {
            this.product_category3 = '';
            this.has_children = '';
            this.user_age_group = '';
            this.gender = '';
            this.marital_status = '';
            this.pet = '';
            this.start_date = '';
            this.end_date = '';
            this.selectedItemss = [];
            this.min_point = '';
            this.max_point = '';
            this.childrenAge = '';
            this.getlist();
        },
        searchuser() {
            if (
                this.product_category3 == '' &&
                this.has_children == '' &&
                this.user_age_group == '' &&
                this.gender == '' &&
                this.marital_status == '' &&
                this.pet == '' &&
                this.selectedItemss == ''&&
                this.start_date == '' &&
                this.end_date == '' &&
                this.min_point == '' &&
                this.max_point == '' &&
                this.childrenAge == ''
            ) {
                this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                this.getlist();
            }
        },
        exceldownload() {
            this.statisticsService
                .getExcelproductCategoryThird(  localStorage.getItem('pcategory'),
                    localStorage.getItem('pcategory2'),
                    this.product_category3,
                    this.has_children == '' ? '' : this.has_children.code,
                    this.user_age_group == '' ? '' : this.user_age_group.code,
                    this.gender == '' ? '' : this.gender.code,
                    this.marital_status == '' ? '' : this.marital_status.code,
                    this.pet == '' ? '' : this.pet.code,
                    this.start_date,
                    this.end_date,
                    this.selectedItemss,
                    this.min_point,
                    this.max_point,
                    this.downloadReason)
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ProductCategoryThirdList.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.closeBasic();
                });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'patch', url: '/user/delete', data: { id: id, status: 'deleted' } }).then(function () {});

                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    self.userService
                        .getUserList(self.nickname, self.username, self.has_children, self.children_age, self.gender, self.age_group, self.marital_status, self.has_pet, self.min_point, self.max_point, self.start_date, self.end_date)
                        .then((data) => {
                            console.log(data);
                            this.customer1 = data;
                            this.loading1 = false;
                            this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                        });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>
